import { getEntityName } from "../../../utils/user/get-entity-name"
import type { ProjectListItem } from "../types/types.ts"

/** The customer a project renders: the linked record, else the typed-in
 *  snapshot. The row and the card have to name the same one. */
const getProjectCustomerName = (
  project?: Pick<ProjectListItem, "customer" | "temporary_customer"> | null,
  fallback = ""
): string =>
  getEntityName(project?.customer || project?.temporary_customer, fallback)

const normalizePercent = (value?: string | number | null): number => {
  if (value == null) return 0
  const num = typeof value === "string" ? parseFloat(value) : value
  return Number.isNaN(num) ? 0 : Math.min(100, Math.max(0, Math.round(num)))
}

export { getProjectCustomerName, normalizePercent }
